// extracted by mini-css-extract-plugin
module.exports = {"container":"KlarnaPlaceholder_container___OHUr","logo":"KlarnaPlaceholder_logo__0usjv","learnMoreLink":"KlarnaPlaceholder_learnMoreLink__bNkxL"};